import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { getOptionsList } from 'services/types';
import { Multiselect, Select } from './fields';
import { MultiInput } from './multi-input';

export const RoleFilter = (props) => {
  const { name = 'role_id', multiple, ...rest } = props;
  const { t } = useTranslation();
  const title = t('form.Роль');

  const items = user.getRoles();

  // multiple
  if (multiple) {
    return <Multiselect type="multiselect" label={title} additionalComponent={MultiInput} data={items} width={'160px'} name={name} {...rest} />;
  }

  // single
  const itemsEl = getOptionsList(items);

  return (
    <Select name={name} type="select" label={title} {...rest}>
      <option value="">{t('filter.Все')}</option>
      {itemsEl}
    </Select>
  );
};

RoleFilter.propTypes = {
  name: PropTypes.string,
  multiple: PropTypes.bool,
};
